export const downloadFile = (filename, url) => {
  const element = document.createElement('a')
  element.setAttribute('href', url)
  element.setAttribute('download', filename)

  element.style.display = 'none'
  document.body.appendChild(element)

  element.click()

  document.body.removeChild(element)
  URL.revokeObjectURL(url)
}
